<div style="height:100%;">


    <kendo-grid class="k-grid k-grid-header custom2" [kendoGridBinding]="displayLogs" kendoGridSelectBy="logId"
        [(selectedKeys)]="selection" [selectable]="{ mode: 'single'}" [loading]="logsLoading" [sortable]="true"
        [size]="smallSize" [resizable]="true" scrollable="virtual" [pageSize]="pageSize" [style.height.%]="100"
        [style.width.vw]="86" [rowHeight]="15" [filterable]="false" (excelExport)="onExcelExport($event)">
        <ng-template kendoGridToolbarTemplate>

            <input type="text" class="kendo-like-input" [style.width.px]="500"
                placeholder="Search on User Name,Company,Project,PO,Object,Action,Description" [(ngModel)]="searchQuery"
                [ngModelOptions]="{ standalone: true }" (ngModelChange)="onSearchInputChange()"
                kendoGridToolbarFocusable />
            <kendo-datepicker [(value)]="searchLog.startDate" [format]="'dd-MMM-yyyy'" [min]="minStartDate"
                [max]="maxStartDate" [style.width.px]="150" placeholder="Start Date">
            </kendo-datepicker>
            <kendo-datepicker [(value)]="searchLog.endDate" [format]="'dd-MMM-yyyy'"
                [min]="searchLog.startDate || minStartDate" [max]="maxStartDate" [style.width.px]="150"
                placeholder="End Date">
            </kendo-datepicker>
            <button class="allbuttons k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary"
                (click)="filterByDateRange()" title="Filter data by selected date range">Filter</button>
            <button class="allbuttons k-button k-button-md k-rounded-md k-button-solid k-button-solid-secondary"
                style="height: 30.5px;" title="Reset Filters" (click)="resetFilters()">
                <span class="k-icon k-i-reset"></span>
            </button>

            <kendo-grid-spacer></kendo-grid-spacer>
            <button class="allbuttons k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary"
                kendoGridExcelCommand [svgIcon]="excelSVG">Export</button>

        </ng-template>


        <kendo-grid-column field="loggedInUserName" title="Logged User" [width]="100"></kendo-grid-column>
        <kendo-grid-column field="timestamp" title="Timestamp(UTC)" [width]="100"></kendo-grid-column>
        <kendo-grid-column field="action" title="Action" [width]="100"></kendo-grid-column>
        <kendo-grid-column field="object" title="Object" [width]="100"></kendo-grid-column>
        <kendo-grid-column field="projectName" title="Project Name" [width]="100"></kendo-grid-column>
        <kendo-grid-column field="portalObjectName" title="PO Name" [width]="100"></kendo-grid-column>
        <kendo-grid-column field="userName" title="User Name" [width]="100"></kendo-grid-column>
        <kendo-grid-column field="companyName" title="Company Name" [width]="100"></kendo-grid-column>
        <kendo-grid-column field="description" title="Description" [width]="100"></kendo-grid-column>
        <kendo-grid-excel [fileName]="getFileName()"></kendo-grid-excel>
    </kendo-grid>
</div>